import React, { useState } from "react";
import { MainLayout } from "layouts";
import { Input, Button, Table, Typography, Alert, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { searchBlock } from "api";

const { TextArea } = Input;
const { Title } = Typography;

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const BlockSearchPage = () => {
  const [inputText, setInputText] = useState("");
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    setError("");
    setResults([]);

    const lines = inputText
      .split(/[\n,]+/)
      .map((s) => s.trim())
      .filter(Boolean);

    if (lines.length === 0) {
      setError("Please enter at least one UUID.");
      return;
    }

    const invalid = lines.filter((l) => !UUID_REGEX.test(l));
    if (invalid.length > 0) {
      setError(`Invalid UUIDs: ${invalid.join(", ")}`);
      return;
    }

    setIsLoading(true);
    const res = await searchBlock(lines);
    if (res.success) {
      setResults(res.payload);
    } else {
      setError("Failed to search blocks. Please try again.");
    }
    setIsLoading(false);
  };

  const baseUrl = window.location.origin;

  const columns = [
    {
      title: "#",
      key: "index",
      width: 60,
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "Adblock UUID",
      dataIndex: "uuid",
      key: "uuid",
      ellipsis: true,
    },
    {
      title: "Link",
      key: "link",
      width: 120,
      render: (_, row) => {
        if (row.found && row.circular_uuid && row.page_uuid) {
          const link = `${baseUrl}/edit/${row.circular_uuid}/${row.page_uuid}/${row.uuid}`;
          return (
            <a href={link} target="_blank" rel="noopener noreferrer">
              Open
            </a>
          );
        }
        return <Tag color="default">Not Found</Tag>;
      },
    },
  ];

  return (
    <MainLayout>
      <div style={{ padding: "40px 20px", width: "100%", maxWidth: 800, margin: "0 auto", flex: 1 }}>
        <Title level={3} style={{ color: "white", textAlign: "center" }}>
          Block Search
        </Title>

        <TextArea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Enter adblock UUIDs (one per line or comma-separated)"
          rows={6}
          style={{ marginBottom: 12 }}
        />

        <Button
          type="primary"
          icon={<SearchOutlined />}
          loading={isLoading}
          onClick={handleSearch}
          style={{ marginBottom: 20 }}
        >
          Search
        </Button>

        {error && (
          <Alert
            type="error"
            message={error}
            showIcon
            closable
            onClose={() => setError("")}
            style={{ marginBottom: 20 }}
          />
        )}

        {results.length > 0 && (
          <Table
            dataSource={results}
            columns={columns}
            rowKey="uuid"
            pagination={false}
            size="middle"
          />
        )}
      </div>
    </MainLayout>
  );
};
